// challenge-steps — step-by-step-challenges (Trello nSM5rv4M): the pure, import-free rules
// behind the challenge's "one requirement at a time" view. challenge-chrome.js renders the
// DOM; everything here is a plain function of the student's `ticked[]` array (one boolean per
// requirement, the SAME array the list view writes), so the current step is never stored —
// it is derived from the ticks. Host-only spec: test/editor/challenge-steps.test.js.
//
// No step is ever locked: the steps are guidance, and Check grades the whole program, so a
// student may look at any step at any time. A step is "done" once the student has moved on from
// it with Next (challenge-chrome.js writes the tick); the tick is only their own progress.

// Honoured iff the server shipped `stepMode: true` (it only does when the stored flag is on,
// the challenge is Modify / Extend and every requirement has a heading) AND the client agrees
// on all of that AND the challenge is not all-optional ("pick any, in any order" contradicts
// locked steps). The client re-checks so a stale or odd payload falls back to the list.
export function stepModeHonoured(answerKey, allOptional) {
  if (!answerKey || answerKey.stepMode !== true) { return false; }
  if (answerKey.mode !== 'modify') { return false; }
  var reqs = answerKey.requirements;
  if (!Array.isArray(reqs) || !reqs.length) { return false; }
  var labelled = reqs.every(function (r) {
    return !!r && typeof r.label === 'string' && r.label.trim() !== '';
  });
  if (!labelled) { return false; }
  return allOptional !== true;
}

// Index of the first unticked step, or -1 when every step is ticked.
export function firstUnticked(ticked) {
  for (var i = 0; i < ticked.length; i++) {
    if (!ticked[i]) { return i; }
  }
  return -1;
}

// The step shown on load: the first unticked one; all ticked → the last step.
export function initialStep(ticked) {
  var first = firstUnticked(ticked);
  if (first !== -1) { return first; }
  return ticked.length ? ticked.length - 1 : 0;
}

// One of 'done' | 'current' | 'open' per index. 'open' = not done and not the one being shown.
export function stepStates(ticked, current) {
  return ticked.map(function (t, i) {
    if (i === current) { return 'current'; }
    return t ? 'done' : 'open';
  });
}

export function isLastStep(ticked, current) {
  return current === ticked.length - 1;
}

// Next is always allowed except from the last step (which ends in "Check my code").
export function canGoNext(ticked, current) {
  return !isLastStep(ticked, current);
}

// A step's description as a list of sub-steps. One per line; a leading "1." / "2)" / "-" / "*"
// is dropped (the list numbers them itself) and blank lines are ignored. A description with a
// single line is NOT a list: the caller shows it as a sentence, exactly as before.
export function subSteps(text) {
  var out = [];
  String(text == null ? '' : text).split(/\r?\n/).forEach(function (line) {
    var t = line.replace(/^\s*(?:\d+[.)]|[-*•])\s+/, '').trim();
    if (t) { out.push(t); }
  });
  return out;
}

// A heading as plain rail text: inline-markdown markers (backticks, `*`) stripped — the same
// strip the list's tick aria-label uses.
export function railText(label) {
  return String(label == null ? '' : label).replace(/[`*]/g, '').trim();
}
